import { culture } from '../../../Helpers/dates';

export const columns = [
  {
    id: 'description',
    noCaption: true,
  },
  {
    id: 'startDate',
    formatCallback: (value) =>
      new Date(value)?.toLocaleDateString(culture, {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      }),
  },
  {
    id: 'endDate',
    formatCallback: (value) =>
      new Date(value)?.toLocaleDateString(culture, {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      }),
  },
];
